import { ComponentProps } from 'react';
import clsx from 'clsx';

import styles from './Tabs.module.css';

interface TabGroupProps extends ComponentProps<'div'> {
  showAsButtonsOnMobile?: boolean;
}

export default function TabGroup({ className, children, showAsButtonsOnMobile = false, ...props }: TabGroupProps) {
  return (
    <div
      className={clsx(styles.tabGroup, className, showAsButtonsOnMobile && styles.mobileButtons)}
      role="tablist"
      {...props}
    >
      {children}
    </div>
  );
}
